import React from 'react'

export default function RedLine(props) {
    return (
        <span style={{width:props.redWidth}} className='redLine'>
        </span>
    )
}
